/**
 * What she said she'd bring up, listed out. The her zone panel opens this on
 * request; it exists mostly so a broken one in `promises.ts` isn't the only
 * way to find out she was keeping score.
 *
 * Drawn fresh on every open, same reasoning as the dossier and the pas-ja
 * sheet: this is her current ledger, not a snapshot worth pinning.
 */

import { Card, ListRow, Sheet } from '@gramas/ui'
import { useEffect, useState } from 'react'
import { type CachedPromise, listActivePromises } from './promises.js'

export interface PromisesSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function PromisesSheet({ open, onOpenChange }: PromisesSheetProps) {
  const [promises, setPromises] = useState<CachedPromise[]>([])

  useEffect(() => {
    if (!open) return
    let cancelled = false
    void listActivePromises().then((list) => {
      if (!cancelled) setPromises(list)
    })
    return () => {
      cancelled = true
    }
  }, [open])

  return (
    <Sheet open={open} onOpenChange={onOpenChange} title="Pažadai">
      <Card className="mx-4 mb-4">
        {promises.length === 0 ? (
          <ListRow title="Pažadų nėra. Kol kas." last />
        ) : (
          promises.map((promise, i) => (
            <ListRow
              key={promise.id}
              last={i === promises.length - 1}
              title={promise.text}
              value={promise.declaredOn}
            />
          ))
        )}
      </Card>
    </Sheet>
  )
}
